import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Item as Response } from '../index.tsx';

export type Request = {
	projectId: string;
	icon: string;
	name: string;
	type: string;
	url: string;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (baseUrl: string, request: Request): Promise<Response> => {
	const { projectId, ...data } = request;
	const url = `${baseUrl}/rest/projects/1.0/project/${projectId}/shortcut`;
	const options = {
		method: 'POST',
		body: JSON.stringify(data),
	};
	return fetchJson(url, options);
};
